import { WindowProvider, useWindowManager } from "./context/WindowContext";
import { Bio } from "./components/Bio/Bio";
import { Header } from "./components/Header/Header";
import { Icons } from "./components/Icons/Icons";
import { LoadingScreen } from "./components/LoadingScreen/LoadingScreen";
import { Notice } from "./components/Notice/Notice";
import { Picture } from "./components/Picture/Picture";
import { EldestOne, ProjectsBin } from "./components/ProjectsBin/ProjectsBin";
import { Voxel } from "./components/Voxel/Voxel";
import { WINDOW_IDS } from "./data/windows";
import { useLoading } from "./hooks/useLoading";

const Desktop = () => {
  const isLoading = useLoading(3000);
  const { isMounted } = useWindowManager();

  return (
    <>
      {isLoading ? <LoadingScreen /> : null}
      <Voxel />
      {isLoading ? null : (
        <>
          <Icons />
          {isMounted(WINDOW_IDS.BIO) ? <Bio /> : null}
          {isMounted(WINDOW_IDS.IMAGE) ? <Picture /> : null}
          {isMounted(WINDOW_IDS.PROJECTS) ? <ProjectsBin /> : null}
          {isMounted(WINDOW_IDS.ELDEST) ? <EldestOne /> : null}
          {isMounted(WINDOW_IDS.NOTICE) ? <Notice /> : null}
          <Header />
        </>
      )}
    </>
  );
};

export const App = () => (
  <WindowProvider>
    <Desktop />
  </WindowProvider>
);

export default App;
